// Verification sources cited across the atlas.
export const VERIFICATION_SOURCES: [string, string][] = [
  [
    'Maine 26 M.R.S. §625-B (statute)',
    'https://legislature.maine.gov/statutes/26/title26sec625-B.html',
  ],
  [
    'Hawaii HRS §394B-10 (statute)',
    'https://law.justia.com/codes/hawaii/title-21/chapter-394b/section-394b-10/',
  ],
  [
    'Ogletree — Maryland mini-WARN in effect',
    'https://ogletree.com/insights-resources/blog-posts/final-warning-marylands-law-mandating-notice-of-mass-layoffs-and-rifs-is-now-in-effect/',
  ],
  ['LayoffData — WARN laws by state (Jun 2026)', 'https://layoffdata.com/blog/warn-laws-by-state/'],
  [
    'National Law Review — mini-WARN acts',
    'https://natlawreview.com/article/state-employment-law-13-states-have-mini-warn-acts',
  ],
  [
    'Colorado 2026 noncompete thresholds',
    'https://www.mondaq.com/unitedstates/employee-benefits-compensation/1749644/colorados-2026-non-compete-salary-thresholds-what-employers-need-to-know',
  ],
  [
    'WA L&I — 2026 noncompete thresholds',
    'https://lawfilesext.leg.wa.gov/law/wsr/2025/20/25-20-099.htm',
  ],
  [
    'DWT — Washington noncompete ban (2027)',
    'https://www.dwt.com/blogs/employment-labor-and-benefits/2026/03/washington-bans-nearly-all-noncompete-agreements',
  ],
  [
    'Nixon Peabody — NY No Severance Ultimatums Act',
    'https://www.nixonpeabody.com/insights/alerts/2026/06/23/new-york-legislature-passes-no-severance-ultimatums-act-awaits-governor',
  ],
  [
    'Seyfarth — NY 2026 session wrap-up',
    'https://www.seyfarth.com/news-insights/employment-updates-from-the-end-of-new-yorks-2026-legislative-session.html',
  ],
  [
    'Nevada NRS 608.020 (statute)',
    'https://law.justia.com/codes/nevada/chapter-608/statute-608-020/',
  ],
  [
    'Wyoming DWS — final pay FAQ',
    'https://dws.wyo.gov/dws-division/labor-standards/workers-and-job-seekers/faq/',
  ],
  [
    'Utah Code ch. 34-28 (statute)',
    'https://le.utah.gov/xcode/Title34/Chapter28/C34-28_1800010118000101.pdf',
  ],
  [
    'Arkansas Code §11-4-405 (statute)',
    'https://law.justia.com/codes/arkansas/title-11/chapter-4/subchapter-4/section-11-4-405/',
  ],
  [
    'OnPay — separation notice requirements',
    'https://onpay.com/insights/separation-notice-requirements-by-state-guide/',
  ],
  ['Rippling — PTO payout laws by state', 'https://www.rippling.com/blog/pto-payout-laws-by-state'],
  [
    'Paycor — final paycheck laws (50-state cross-check)',
    'https://www.paycor.com/resource-center/articles/final-paycheck-laws-by-state/',
  ],
  [
    'Tex. Lab. Code §61.014 (statute)',
    'https://texas.public.law/statutes/tex._labor_code_section_61.014',
  ],
  ['A.R.S. §23-353 (statute)', 'https://www.azleg.gov/ars/23/00353.htm'],
  [
    'Massachusetts final pay, c.149 §148',
    'https://masswagelaw.com/massachusetts-laws-governing-final-pay/',
  ],
  [
    '19 Del. C. §1103 (statute)',
    'https://law.justia.com/codes/delaware/title-19/chapter-11/section-1103/',
  ],
  ['Ohio R.C. §4113.15 (statute)', 'https://codes.ohio.gov/ohio-revised-code/section-4113.15'],
  ['40 O.S. §165.3 (statute)', 'https://law.justia.com/codes/oklahoma/title-40/section-40-165-3/'],
  [
    'Ohio vacation payout case law',
    'https://finneylawfirm.com/are-employees-legally-entitled-to-their-unused-vacation-pay-when-their-employment-ends/',
  ],
  [
    '26 M.R.S. §626, Maine vacation payout (statute)',
    'https://legislature.maine.gov/statutes/26/title26sec626.html',
  ],
  [
    'R.I. Gen. Laws §28-14-4 (statute)',
    'https://webserver.rilegislature.gov/Statutes/TITLE28/28-14/28-14-4.htm',
  ],
  [
    'Conn. Gen. Stat. §31-51o (statute)',
    'https://law.justia.com/codes/connecticut/2023/title-31/chapter-557/section-31-51o/',
  ],
  ['S.C. Code ch. 41-1 (§41-1-40 repealed 2010)', 'https://www.scstatehouse.gov/code/t41c001.php'],
  [
    'Littler — Nebraska WARN Act',
    'https://www.littler.com/news-analysis/asap/nebraska-enacts-state-mini-warn-act',
  ],
  [
    'Greenberg Traurig — NJ mandatory severance',
    'https://www.gtlaw.com/en/insights/2023/5/new-jerseys-miniwarn-act-amendments-including-mandatory-severance-now-in-effect',
  ],
  ['Minn. Stat. §363A.31 (statute)', 'https://www.revisor.mn.gov/statutes/cite/363a.31'],
  ['NY Labor Law §195 (statute)', 'https://www.nysenate.gov/legislation/laws/LAB/195'],
  ['NY GOL §5-336 (statute)', 'https://www.nysenate.gov/legislation/laws/GOB/5-336'],
  [
    'NY DOL — Record of Employment IA 12.3',
    'https://dol.ny.gov/record-employment-ia123-right-apply-unemployment-form',
  ],
  [
    'Cal. Gov. Code §12964.5 (statute)',
    'https://california.public.law/codes/government_code_section_12964.5',
  ],
  [
    'Epstein Becker Green — 2026 noncompete thresholds',
    'https://www.tradesecretsandemployeemobility.com/raising-the-cost-of-noncompetes-2026-state-noncompete-salary-threshold-changes',
  ],
  [
    'Littler — Wyoming noncompete ban',
    'https://www.littler.com/news-analysis/asap/wyoming-bans-non-compete-covenants-some-exceptions',
  ],
  [
    'MCA §39-2-801 (statute)',
    'https://leg.mt.gov/bills/mca/title_0390/chapter_0020/part_0080/section_0010/0390-0020-0080-0010.html',
  ],
  [
    'K.S.A. §44-808 (statute)',
    'https://codes.findlaw.com/ks/chapter-44-labor-and-industries/ks-st-sect-44-808/',
  ],
  [
    'Ind. Code §22-6-3-1 (statute)',
    'https://law.justia.com/codes/indiana/title-22/article-6/chapter-3/section-22-6-3-1/',
  ],
  ['ORS 285A.516 (statute)', 'https://oregon.public.law/statutes/ors_285a.516'],
  [
    'Venable — McLaren Macomb status, 2026',
    'https://www.venable.com/insights/publications/2026/06/will-the-nlrb-revisit-mclaren-macomb',
  ],
  [
    'US DOL — COBRA FAQs',
    'https://www.dol.gov/agencies/ebsa/about-ebsa/our-activities/resource-center/faqs/cobra-continuation-health-coverage-workers',
  ],
  [
    'CMS — COBRA Q&A',
    'https://www.cms.gov/cciio/programs-and-initiatives/other-insurance-protections/cobra_qna',
  ],
  [
    'Medicare Rights Center — Part B SEP',
    'https://cdn1.medicareinteractive.org/wp-content/uploads/Medicare-Part-B-SEP.pdf',
  ],
  [
    'KFF — 2026 marketplace after subsidy expiry',
    'https://www.kff.org/affordable-care-act/what-we-know-so-far-about-2026-aca-marketplace-enrollment-premiums-and-deductibles/',
  ],
  [
    'FindCoverage — mini-COBRA by state (2026)',
    'https://findcoverage.net/mini-cobra-state-law-2026/',
  ],
  [
    'CobraHelp — state continuation laws (aggregator)',
    'https://www.mycobrahelp.com/blog/what-are-the-cobra-laws-state-by-state/',
  ],
  [
    'HR Certification — mini-COBRA 2026',
    'https://hrcertification.com/blog/state-mini-cobra-laws-2026-biid1000358',
  ],
  [
    'Mass.gov — MiniCOBRA guide',
    'https://www.mass.gov/info-details/minicobra-continuation-of-coverage-benefits-guide',
  ],
  ['A.R.S. §20-2330 (statute)', 'https://www.azleg.gov/ars/20/02330.htm'],
  [
    'SDCL §58-18-7.5 (statute)',
    'https://law.justia.com/codes/south-dakota/2022/title-58/chapter-18/section-58-18-7-5/',
  ],
  ['RSMo §376.428 (statute)', 'https://revisor.mo.gov/main/OneSection.aspx?section=376.428'],
  [
    'Ind. Code §27-8-15-31.1 (statute)',
    'https://codes.findlaw.com/in/title-27-insurance/in-code-sect-27-8-15-31-1/',
  ],
  [
    'W.S. §26-19-113 (statute)',
    'https://law.justia.com/codes/wyoming/title-26/chapter-19/article-1/section-26-19-113/',
  ],
  [
    '8 V.S.A. §4090a (statute)',
    'https://law.justia.com/codes/vermont/2018/title-8/chapter-107/section-4090a/',
  ],
  [
    'HRS §393-15 (statute)',
    'https://www.capitol.hawaii.gov/hrscurrent/vol07_ch0346-0398/hrs0393/HRS_0393-0015.htm',
  ],
  [
    'O.C.G.A. §33-24-21.2 (statute)',
    'https://law.justia.com/codes/georgia/title-33/chapter-24/article-1/section-33-24-21-2/',
  ],
  [
    '215 ILCS 5/367.2 (statute)',
    'https://www.ilga.gov/legislation/ilcs/fulltext.asp?DocName=021500050K367.2',
  ],
  [
    'CalChamber — Cal-COBRA extension',
    'https://p-hrcalifornia.calchamber.com/hr-library/benefits/cobra-calcobra/cal-cobra-interaction-with-cobra',
  ],
  [
    'NY DFS — continuation and age-29 coverage',
    'https://www.dfs.ny.gov/consumers/health_insurance/cobra_and_premium_assistance',
  ],
  [
    'OkayNext — severance and unemployment by state',
    'https://www.okaynext.app/guides/severance-by-state',
  ],
  [
    'SeveranceCalc — severance and unemployment',
    'https://severancecalc.com/blog/severance-pay-and-unemployment',
  ],
  [
    'O’Flaherty Law — Illinois severance and UI',
    'https://www.oflaherty-law.com/learn-about-law/does-severance-pay-affect-unemployment-in-illinois',
  ],
  [
    'Virginia Employment Commission — benefits eligibility',
    'https://www.vec.virginia.gov/benefits-eligibility',
  ],
  [
    'Georgia DOL — UI claimant handbook',
    'https://dol.georgia.gov/document/unemployment-benefits/ui-claimant-handbook/download',
  ],
  [
    'Fidelity — Rule of 55',
    'https://www.fidelity.com/learning-center/personal-finance/what-is-rule-of-55',
  ],
  [
    'AARP — severance and Social Security',
    'https://www.aarp.org/social-security/faq/severance-pay/',
  ],
  ['CRS — Trade Adjustment Assistance status', 'https://www.congress.gov/crs-product/R47200'],
  [
    'BPC — displaced worker programs',
    'https://bipartisanpolicy.org/explainer/what-happens-when-jobs-disappear-a-guide-to-displaced-worker-programs-in-the-u-s/',
  ],
  [
    'WA ESD — Training Benefits',
    'https://esd.wa.gov/jobs-and-training/job-training-support/training-benefits-program',
  ],
  ['Oregon — Training UI', 'https://unemployment.oregon.gov/tui'],
  ['26 M.R.S. §1196 (statute)', 'https://legislature.maine.gov/statutes/26/title26sec1196.html'],
  ['California Employment Training Panel', 'https://etp.ca.gov/about-us/'],
  ['TWC — Skills Development Fund', 'https://www.twc.texas.gov/programs/skills-development-fund'],
  [
    'Massachusetts Workforce Training Fund',
    'https://commcorp.org/program/workforce-training-fund-program/',
  ],
]
